export { default } from './SkeletonMonthlyHistogram';
